import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DataService_DigitalID_Settings } from "../shared/data.service";
import { DigitalIDSchoolRequest } from "../shared/DigitalIDSchoolRequest";

@Component({
	selector: "caass-digital-id-pbis-settings",
	templateUrl: "./digital-id-pbis-settings.component.html",
	styleUrls: ["./digital-id-pbis-settings.component.css"],
})
export class DigitalIdPbisSettingsComponent implements OnInit {
	constructor(private DigitalIDPBISService: DataService_DigitalID_Settings, private confirmationService: ConfirmationService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadSchool();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	///////////////
	// Built-In
	///////////////

	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchools: any = [];
	lstSchool: any = [];

	//Filter lists
	lstPBISEnabledDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
		// { field: 'PBISEnabledDesc', header: 'Enabled' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchool() {
		this.errorMessage = "";

		this.loading = true;

		var result = this.DigitalIDPBISService.DigitalIDSchoolPBISSelectList();
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				//Load Data Filter Lists
				this.lstPBISEnabledDesc = Array.from(new Set(this.lstSchool.map((item: any) => item.PBISEnabledDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadSchool();
	}

	//Custom Button Methods

	onEnable() {
		this.errorMessage = "";

		//
		// Error Handling
		//
		if (this.SelectedSchools.length == 0) {
			this.errorMessage = "Select schools to enable showing PBIS points";
			return;
		}

		this.loading = true;

		//
		// Create Parms
		//
		var lstSIDs: number[] = [];

		for (var z = 0; z < this.SelectedSchools.length; z++) {
			var next = this.SelectedSchools[z];

			lstSIDs = [...lstSIDs, next.SchoolID];
		}

		var parms: DigitalIDSchoolRequest = {
			lstSchoolIDs: lstSIDs,
		};

		//
		// Call WS
		//

		var result = this.DigitalIDPBISService.SchoolPBISEnable(parms);
		result.subscribe(
			(response) => {
				this.loading = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "pbis",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Preferences were updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.SelectedSchools = [];
							this.loadSchool();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "pbis",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update school preferences",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	onDisable() {
		this.errorMessage = "";

		//
		// Error Handling
		//
		if (this.SelectedSchools.length == 0) {
			this.errorMessage = "Select schools to disable showing PBIS points";
			return;
		}

		this.loading = true;

		//
		// Create Parms
		//
		var lstSIDs: number[] = [];

		for (var z = 0; z < this.SelectedSchools.length; z++) {
			var next = this.SelectedSchools[z];

			lstSIDs = [...lstSIDs, next.SchoolID];
		}

		var parms: DigitalIDSchoolRequest = {
			lstSchoolIDs: lstSIDs,
		};

		//
		// Call WS
		//

		var result = this.DigitalIDPBISService.SchoolPBISDisable(parms);
		result.subscribe(
			(response) => {
				this.loading = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "pbis",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Preferences were updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.SelectedSchools = [];
							this.loadSchool();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "pbis",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update school preferences",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	onRowDblClick(School) {}
	////////////////////////////////////////////
}
